import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-drivers-salary-confirm-history',
	templateUrl: './drivers-salary-confirm-history.component.html',
	styleUrls: ['./drivers-salary-confirm-history.component.scss'],
})
export class DriversSalaryConfirmHistoryComponent {
	@Input() data: Array<any>;

	headers = [{ label: 'LP' }, { label: 'Data zatwierdzenia' }, { label: 'Użytkownik' }];
}
